import { ButtonHTMLAttributes, forwardRef } from 'react';
import Loader from '../../components/Common/Loader';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string | any;
  loader?: boolean;
  iconTemplate?: React.ReactElement;
  disabled?: boolean;
  tooltip?: string;
  onClick?: () => void;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { title, loader, iconTemplate, onClick, className, disabled, tooltip, ...props }: ButtonProps,
    ref
  ) => {
    return (
      <div className="flex gap-3">
        <button
          {...props}
          ref={ref}
          onClick={onClick}
          className={className}
          disabled={loader || disabled}
          title={tooltip}
        >
          <span className="flex items-center justify-center">{title}</span>
          {loader ? <Loader loader={loader} /> : iconTemplate && iconTemplate || ''}
        </button>
      </div>
    );
  });

export default Button;
